import * as React from 'react';
const AbrasioniIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M49.09 102.83h.01v.01h-.01zM57.74 102.82h.01v.02h-.01zM66.4 102.82h.01v.01h-.01zM75.05 102.82h.01v.01h-.01zM49.1 109.4h.01v.01h-.01zM57.76 109.4h.01v.01h-.01zM66.41 109.39h.02v.01h-.02zM75.07 109.39h.01v.01h-.01z"
      className="prefix__cls-1"
    />
    <path
      d="M110.19 90.06c0 2.16 5.46 2.19 8.29 2.11 1.44-.03 2.89-.05 4.33-.05h21.76c2.15 0 3.9 1.75 3.9 3.9v.48c0 2.16-1.75 3.91-3.9 3.91h-19.9M122.04 116.97h10.57c2.26 0 4.24 1.85 4.12 4.11-.05 1-.48 1.9-1.14 2.56-.7.7-1.68 1.15-2.76 1.15 0 0-24.22.45-29.15.45-4.47 0-9.45-.36-13.71-1.8-4.92-1.66-6.8-5.61-6.67-10.61"
      className="prefix__cls-2"
    />
    <path
      d="M117.49 116.97h25.63c2.15 0 3.9-1.75 3.9-3.9v-.48c0-2.16-1.75-3.91-3.9-3.91h-19.78"
      className="prefix__cls-2"
    />
    <path
      d="M120.83 100.41h27.26a3.91 3.91 0 0 1 3.91 3.91v.47a3.91 3.91 0 0 1-3.91 3.91h-28.04M114.83 88.36c7.9-3.14 8.95-7.53 8.67-10.89-.17-2.12-2.26-3.33-4.15-2.37-2.62 1.33-8.82 6.7-14.94 7.82-5.06 1.1-9.31 1.9-12.42 3-2.57.9-5.81 2.22-7.26 4.69-1.77 2.66-1.38 6.64-1.38 6.64M96.92 103.27s1.19-.52 2.72-1.64"
      className="prefix__cls-2"
    />
    <path
      d="M114.83 88.36c-1.42 1.14-7.45 1.1-9.15 5.19-.66 2.04-1.69 3.73-2.84 5.09M83.29 92.38H48.01M83.74 119.87H48"
      className="prefix__cls-2"
    />
    <path d="M66.4 102.82h8.66M66.18 109.4H49.1" className="prefix__cls-1" />
  </svg>
);
export default AbrasioniIcon;
